import React, { useEffect, useState } from 'react';
import { Row, Col, Table, message, Typography, Space } from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import FileConstants from '../../../../FileConstants';
import useTableFilter from "../../UseTableFilter/useTableFilter";
import moment from "moment";

const { Text } = Typography;

export default function AdminTransactionsDetails() {
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [getColumnSearchProps] = useTableFilter();

    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    const fetchTransactions = async () => {
        try {
            setIsLoading(true);
            const payload = {
                action: "get_subscription_transactions"
            };

            const response = await axios.post(ENVIRONMENT.GET_SYSTEM_ANALYTICS, payload);
            const data = response.data || [];
            
            // Sort by time descending if not already
            const sortedData = data.sort((a, b) => moment(b.request_time).unix() - moment(a.request_time).unix());
            setTransactions(sortedData);
        } catch (error) {
            console.error("Error fetching transactions:", error);
            message.error("Failed to fetch transactions.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactions();
    }, []);

    const columns = [
        {
            title: <span className="manrope f-14 black-14">Username</span>,
            dataIndex: 'customer_username',
            key: 'customer_username',
            ...getColumnSearchProps('customer_username'),
            render: text => <span className="manrope f-12 black-14">{text}</span>
        },
        {
            title: <span className="manrope f-14 black-14">Company</span>,
            dataIndex: 'company_name',
            key: 'company_name',
            ...getColumnSearchProps('company_name'),
            render: text => <span className="manrope f-12 black-14">{text}</span>
        },
        {
            title: <span className="manrope f-14 black-14">Request Type</span>,
            dataIndex: 'request_type',
            key: 'request_type',
            ...getColumnSearchProps('request_type'),
            render: (text) => (
                <span className="manrope f-12 black-14">{FileConstants.setRequestTypeText(text)}</span>
            )
        },
        {
            title: <span className="manrope f-14 black-14">Transaction Time</span>,
            dataIndex: 'request_time',
            key: 'request_time',
            sorter: (a, b) => moment(a.request_time).unix() - moment(b.request_time).unix(),
            render: text => <span className="manrope f-12 black-14">{text}</span>
        },
        {
            title: <span className="manrope f-14 black-14">Amount</span>,
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: text => <span className="manrope f-12 green w-600">${text/100}</span>,
        },
        {
            title: <span className="manrope f-14 black-14">Receipt</span>,
            dataIndex: 'receipt_url',
            key: 'receipt_url',
            render: (url) => url ? <a className="manrope f-12" href={url} target="_blank" rel="noopener noreferrer">View Receipt</a> : '-'
        },
    ];

    return (
        <div style={{ padding: '0 20px' }}>
            <Row gutter={[24, 24]}>
                <Col span={24}>
                    <Table
                        columns={columns}
                        dataSource={transactions}
                        loading={{ indicator: antIcon, spinning: isLoading }}
                        pagination={{ pageSize: 15 }}
                        size="middle"
                        rowKey="transaction_id"
                        style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}
                    />
                </Col>
            </Row>
        </div>
    );
}
